import clsx from "clsx";
import type React from "react";
import type { ComponentProps, PropsWithChildren, PropsWithoutRef } from "react";
interface Props extends PropsWithChildren {
  label?: PropsWithoutRef<ComponentProps<'label'>>;
  span?: PropsWithoutRef<ComponentProps<'span'>>;
  input: PropsWithoutRef<ComponentProps<'input'>>;
  text: PropsWithoutRef<ComponentProps<'span'>>;
  logo?: React.ReactNode;
  tip?: React.ReactNode;
  getCheckboxVal?: any;
};
export default function Checkbox({label = {}, span = {}, input, text, logo, tip, getCheckboxVal, children}:Props) {
  const {color: labelClass = "[&:has(input:checked)]:border-green bg-white rounded-lg p-4 flex gap-3 items-center font-semibold border min-h-[88px]", ...labelProps} = label;
  const {color: spanClass = "space-x-3 flex items-center", ...spanProps} = span;
  const {children:textChildren, ...textProps} = text;
  const {value = undefined, type: inputType, className: inputClass = "border-split appearance-none focus:ring-0 focus:ring-white checked:bg-white checked:text-black checked:border-green checked:bg-[url('https://assets.avepoint.com/upload/icons/form-check.svg')] checked:bg-[length:12px_12px] rounded w-5 h-5", ...inputProps} = input;
  const inputValue = value || textChildren?.toString();
  return (
    <label className={clsx(labelClass, logo?'justify-between':'')} {...labelProps}>
      {logo?<>
        <span className={spanClass} {...spanProps}>
          <input className={inputClass} type="checkbox" value={inputValue} {...inputProps} onChange={(e)=>!!getCheckboxVal && getCheckboxVal(e.target)} />
          <span {...textProps}>{textChildren?.toString()}</span>
        </span>
        {logo}
      </>:<>
        <input className={inputClass} type="checkbox" value={inputValue} {...inputProps} onChange={(e)=>!!getCheckboxVal && getCheckboxVal(e.target)} />
        <span {...textProps}>{textChildren?.toString()}</span>
      </>}
    </label>
  );
}